// Admins sometimes enter the success redirect URL without a scheme ("admin.example.com").
// The browser treats that as a path relative to the page the form is embedded on, so add
// https:// to it. Absolute URLs and explicit paths ("/thanks", "./thanks", "?done=1",
// "#done") are left as they are.
export function normalizeRedirectUrl(url) {
    const value = (url || "").trim();
    if (!value) return null;
    if (/^[a-z][a-z\d+\-.]*:\/\//i.test(value) || /^[/.?#]/.test(value)) return value;
    return `https://${value}`;
}
